import * as React from 'react';
import {Avatar, Button, Typography} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import axios from "../../axios";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useComments} from "./hooks/useComments";
import ActualityCommentAnswerList from "./ActualityCommentAnswerList";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import AvatarProfile from "../dashboard/AvatarProfile";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";


const ActualityComment = ({actualityId}) => {
    const [commentInput, setCommentInput] = useState('');
    const [showError, setShowError] = useState(false);
    const {addComment} = useComments(actualityId);
    const {mode} = useDarkMode();

    const validateData = (comment) => {
        if (comment === "") {
            setShowError(true);
            return false;
        }
        return true;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if (validateData(data.get('commentInput'))) {
            addComment(data.get('commentInput'));
            setCommentInput('');
        }
    }

    const {police} = usePoliceMode();

    return(
        <div>
            <Typography component={"form"} class={"inputComment"} onSubmit={handleSubmit}>
                    <div><AvatarProfile size={40} showName={false}/></div>
                    <input aria-label={"champ contenu du commentaire"}
                        id="commentInput" name="commentInput"
                        type="text" placeholder={"Ecrivez un commentaire"}
                        onChange={event => setCommentInput(event.target.value)}
                        value={commentInput}
                        onFocus={() => setShowError(false)}
                        style={{
                           color : mode.settings.textColor3,
                           backgroundColor : mode.settings.inputBackgroundColor,
                           fontFamily: police.normalMode ? 'Roboto' : 'Comic Sans MS'
                        }}
                    />
                    {
                        showError ? <span className="tooltiptext" id="tooltipdemo">Veuillez remplir ce champ.</span>:<div></div>
                    }
                    <Button className='buttonOhs' startIcon={<SendIcon role="img" aria-label={"Publier le commentaire"}/>} style={{paddingLeft: 15}} type="submit">
                        <Typography variant={'subtitle1'}>Publier</Typography>
                    </Button>
            </Typography>
            <ActualityCommentAnswerList actualityId={actualityId}></ActualityCommentAnswerList>
        </div>
    )
}

export default ActualityComment;
